<gpu-full-screen-modal-layout>
  <gpu-modal-header-logo>
    <img src="/assets/images/geneplanet.svg" width="200px" />
  </gpu-modal-header-logo>

  <gpu-modal-header-close-button
    (click)="modal.dismiss()"
  ></gpu-modal-header-close-button>

  <div class="container gpx-md-40 gpy-8">
    <div class="col-12 col-lg-8 gmt-24 ms-auto me-auto p-0">
      <h4 class="h4-extrabold gmb-24">
        <span>{{ 'COOKIESSETTINGSPAGE.PAGETITLE' | translate }}</span>
      </h4>
      <div *ngIf="cookieSettings">
        <div class="row">
          <div
            class="col col-12"
            *ngFor="let paragraph of cookiesSettingsParagraphs"
          >
            <p class="p3-regular text-secondary gmb-24">{{ paragraph }}</p>
          </div>
        </div>

        <div class="cookie-categories row">
          <!-- necessary -->
          <div class="col-12 gpy-8 border-top">
            <div class="cookies-category-setting">
              <div class="d-flex align-items-center">
                <gpu-switch
                  [id]="'necessary'"
                  [checked]="true"
                  [disabled]="true"
                ></gpu-switch>
                <div
                  class="gml-24 w-100 pointer"
                  (click)="
                    visibleSettings.necessary = !visibleSettings.necessary
                  "
                >
                  <h5 class="h7-bold gmy-0">
                    <span
                      translate="COOKIESSETTINGSPAGE.CATEGORIES.0.NAME"
                    ></span>
                  </h5>
                  <span class="p3-regular text-secondary">
                    {{ 'COOKIESSETTINGSPAGE.ALWAYS' | translate }}
                  </span>
                </div>
                <i
                  class="pointer text-gray gpicon-lg gpicon-{{
                    visibleSettings.necessary ? 'up' : 'down'
                  }}"
                  (click)="
                    visibleSettings.necessary = !visibleSettings.necessary
                  "
                ></i>
              </div>
              <div class="gmt-32 gmb-16" *ngIf="visibleSettings.necessary">
                <p
                  class="p3-regular text-muted"
                  [innerHTML]="
                    'COOKIESSETTINGSPAGE.CATEGORIES.0.DESCRIPTION' | translate
                  "
                ></p>
              </div>
            </div>
          </div>

          <!-- preference -->
          <div class="col-12 gpy-8 border-top">
            <div class="cookies-category-setting">
              <div class="d-flex align-items-center">
                <gpu-switch
                  [id]="'pref'"
                  [checked]="cookieSettings.cookies_pref"
                  (change)="checkboxClicked('cookies_pref')"
                ></gpu-switch>
                <div
                  class="ms-4 w-100 pointer"
                  (click)="
                    visibleSettings.preference = !visibleSettings.preference
                  "
                >
                  <h5 class="h7-bold gmy-0">
                    <span
                      translate="COOKIESSETTINGSPAGE.CATEGORIES.1.NAME"
                    ></span>
                  </h5>
                  <span class="p3-regular text-secondary">
                    {{
                      (cookieSettings.cookies_pref === 1
                        ? 'COOKIESSETTINGSPAGE.ALLOW'
                        : 'COOKIESSETTINGSPAGE.DECLINE'
                      ) | translate
                    }}
                  </span>
                </div>
                <i
                  class="pointer text-gray gpicon-lg gpicon-{{
                    visibleSettings.preference ? 'up' : 'down'
                  }} "
                  (click)="
                    visibleSettings.preference = !visibleSettings.preference
                  "
                ></i>
              </div>
              <div class="gmt-32 gmb-16" *ngIf="visibleSettings.preference">
                <p
                  class="p3-regular text-muted"
                  [innerHTML]="
                    'COOKIESSETTINGSPAGE.CATEGORIES.1.DESCRIPTION' | translate
                  "
                ></p>
              </div>
            </div>
          </div>

          <!-- statistic -->
          <div class="col-12 gpy-8 border-top">
            <div class="cookies-category-setting">
              <div class="d-flex align-items-center">
                <gpu-switch
                  [id]="'stat'"
                  [checked]="cookieSettings.cookies_stat"
                  (change)="checkboxClicked('cookies_stat')"
                ></gpu-switch>
                <div
                  class="gml-24 w-100 pointer"
                  (click)="
                    visibleSettings.statistic = !visibleSettings.statistic
                  "
                >
                  <h5 class="h7-bold gmy-0">
                    <span
                      translate="COOKIESSETTINGSPAGE.CATEGORIES.2.NAME"
                    ></span>
                  </h5>
                  <span class="p3-regular text-secondary">
                    {{
                      (cookieSettings.cookies_stat === 1
                        ? 'COOKIESSETTINGSPAGE.ALLOW'
                        : 'COOKIESSETTINGSPAGE.DECLINE'
                      ) | translate
                    }}
                  </span>
                </div>
                <i
                  class="pointer text-gray gpicon-lg gpicon-{{
                    visibleSettings.statistic ? 'up' : 'down'
                  }}"
                  (click)="
                    visibleSettings.statistic = !visibleSettings.statistic
                  "
                ></i>
              </div>
              <div class="gmt-32 gmb-16" *ngIf="visibleSettings.statistic">
                <p
                  class="p3-regular text-muted"
                  [innerHTML]="
                    'COOKIESSETTINGSPAGE.CATEGORIES.2.DESCRIPTION' | translate
                  "
                ></p>
              </div>
            </div>
          </div>

          <!-- marketing -->
          <div class="col-12 gpy-8 border-top border-bottom">
            <div class="cookies-category-setting">
              <div class="d-flex align-items-center">
                <gpu-switch
                  [id]="'mkt'"
                  [checked]="cookieSettings.cookies_mkt"
                  (change)="checkboxClicked('cookies_mkt')"
                ></gpu-switch>
                <div
                  class="gml-24 w-100 pointer"
                  (click)="
                    visibleSettings.marketing = !visibleSettings.marketing
                  "
                >
                  <h5 class="h7-bold gmy-0">
                    <span
                      translate="COOKIESSETTINGSPAGE.CATEGORIES.3.NAME"
                    ></span>
                  </h5>
                  <span class="p3-regular text-secondary">
                    {{
                      (cookieSettings.cookies_mkt === 1
                        ? 'COOKIESSETTINGSPAGE.ALLOW'
                        : 'COOKIESSETTINGSPAGE.DECLINE'
                      ) | translate
                    }}
                  </span>
                </div>
                <i
                  class="pointer text-gray gpicon-lg gpicon-{{
                    visibleSettings.marketing ? 'up' : 'down'
                  }} my-auto"
                  (click)="
                    visibleSettings.marketing = !visibleSettings.marketing
                  "
                ></i>
              </div>
              <div class="gmt-32 gmb-16" *ngIf="visibleSettings.marketing">
                <p
                  class="p3-regular text-muted"
                  [innerHTML]="
                    'COOKIESSETTINGSPAGE.CATEGORIES.3.DESCRIPTION' | translate
                  "
                ></p>
              </div>
            </div>
          </div>
        </div>

        <div
          class="row gmt-48 gmt-md-32 gmb-24 px-3 px-sm-4 d-flex justify-content-center"
        >
          <button
            class="save-button gbtn-1 gbtn-sq b2-semibold text-primary gmx-12 gmb-24"
            (click)="saveCookieSettings()"
          >
            {{ 'COOKIESSETTINGSPAGE.SAVESETTINGS' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</gpu-full-screen-modal-layout>
